import type { PublicationDto } from '../publishing/dto';

export enum StepPlacement {
  /** Ближайший свободный слот канала не раньше «первый шаг + задержка». */
  Slot = 'slot',
  /** Ровно «первый шаг + задержка». */
  Exact = 'exact',
}

export interface SchemeStep {
  channelId: string;
  /** Задержка от первого шага, минуты; у первого шага — 0. */
  delayMinutes: number;
  placement: StepPlacement;
}

export interface SchemeDto {
  id: string;
  blogId: string;
  name: string;
  steps: SchemeStep[];
  /** Сколько постов стоит в очереди по схеме (SCH-UC-1.CC-1). */
  queueCount: number;
  createdAt: string;
  updatedAt: string;
}

// SCH-UC-1
export interface SaveSchemeRequestDto {
  name: string;
  steps: SchemeStep[];
}

// SCH-UC-3
export interface QueueItemDto {
  id: string;
  postId: string;
  postTitle: string;
  schemeId: string;
  schemeName: string;
  position: number;
  publications: PublicationDto[];
  /** SCH-RULE-2: хотя бы у одного шага нет времени. */
  unplanned: boolean;
}

// SCH-UC-2
export interface EnqueueRequestDto {
  postId: string;
  schemeId: string;
}

export interface ReorderQueueRequestDto {
  itemIds: string[];
}

// SCH-UC-5
export interface SchedulePostRequestDto {
  schemeId: string;
  /** Момент первого шага, ISO-8601. */
  at: string;
}

// SCH-UC-6
export interface ReschedulePublicationRequestDto {
  plannedAt: string;
}

// SCH-UC-7
export interface CalendarQuery {
  from: string;
  to: string;
  channelId?: string;
}

export const SCHEME_NAME_MAX_LENGTH = 100;
export const SCHEME_MAX_STEPS = 10;
export const MAX_STEP_DELAY_MINUTES = 60 * 24 * 60;
/** SCH-RULE-2: горизонт поиска свободного слота. */
export const PLANNING_HORIZON_DAYS = 366;
